/**
 * Toggles visibility of <option> elements, based on another <select>'s value
 * @example
 *   <select id="make">
 *     <option value="Audi">Audi</option>      <- Selecting this..
 *     <option value="BMW">BMW</option>
 *   </select>
 *   <!-- ... -->
 *   <select id="model">
 *     <option data-filter="Audi">A4</option>  <- shows this,
 *     <option data-filter="BMW">M3</option>   <- and hides this.
 *   </select>
 */
class OptionFilter {
  /**
   * Initializes an OptionFilter with the given elements
   * @param {Object} options -
   * @param {HTMLElement} filterSelect - The select that's value filters the options
   * @param {HTMLElement} targetSelect - The select that's options get filtered
   * @param {String} [dataKey=filter] - The data attribute to look for in <option>
   */
  constructor({
    filterSelect,
    targetSelect,
    dataKey = 'filter'
  }) {
    this.dataKey = dataKey;
    this.filterSelect = filterSelect;
    this.targetSelect = targetSelect;
    this.filterSelect.addEventListener('change', () => this.handleChange());
    this.handleChange();
  }

  /**
   * Applies the currently selected filter
   */
  handleChange() {
    const filterValue = this.filterSelect.value.toLowerCase();
    Array.from(this.targetSelect.options).forEach(option => {
      const dataValue = option.dataset[this.dataKey];
      if(!dataValue) {
        // ignore <option>s that don't have the data-attribute
        return;
      }
      option.selected = false;
      option.hidden = dataValue.toLowerCase() !== filterValue;
    });
    // Reset the current selection
    this.targetSelect.selectedIndex = -1;
    this.targetSelect.value = '';
    const changeEvent = new Event('change');
    this.targetSelect.dispatchEvent(changeEvent);
  }
}

export { OptionFilter };
export default OptionFilter;
